// Die Beobachtungsgründe, lesbar.
//
// Anders als die Fallarten stehen diese Werte NICHT als CHECK im Schema,
// sondern als `REASONS` im WatchlistService — dort begründet: Ein
// CheckViolation käme als 500 an, und der Aufrufer suchte den Fehler beim
// Server statt bei sich.
//
// Deshalb sind sie hier auch nicht bloß Übersetzung, sondern die AUSWAHL des
// Dialogs: Was hier steht, kann man ankreuzen. `tests/test_vokabular_abgleich.py`
// gleicht die Liste gegen den Dienst ab — ein Grund, den nur eine der beiden
// Seiten kennt, fällt beim Testlauf auf.

export const WATCHLIST_REASON: Record<string, string> = {
  RISK_PROFILING: 'Risikoprofil',
  DAILY_STRETCH: 'Daily Stretch',
  BUY_THE_DIP: 'Buy the Dip',
}

// Wozu der Grund dient — im Dialog unter der Bezeichnung. Ohne ihn steht dort
// eine Abkürzung, die nur kennt, wer die Reports schon benutzt hat.
export const WATCHLIST_REASON_HINT: Record<string, string> = {
  RISK_PROFILING: 'zur Einschätzung des Risikoprofils',
  DAILY_STRETCH: 'Kandidat des täglichen Ausreißer-Reports',
  BUY_THE_DIP: 'soll bei Rückschlägen gekauft werden',
}

/** Die Bezeichnung, oder der Rohwert — sichtbar falsch statt unsichtbar leer. */
export const grundName = (wert: string) => WATCHLIST_REASON[wert] ?? wert
